import React, { useEffect, useState, useRef, useMemo, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleUp, faArrowLeft, faToggleOff, faToggleOn } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";

import "./styles.scss";

import SOTable from "./SOTable";
import InTable from "./InTable";
import OutTable from "./OutTable";
import QCTable from "./QCTable";
import COMTable from "./ComTable";
import RevData from "./DnDTables/RevTable";
import ComTextarea from "pages/Create/DnDTables/ComTextarea";

import ModalPortal from "util/component/Modal";
import { Modal, Rev, RevLog } from "util/component/Modal/Modal";
import SearchableSelect from "util/component/SearchableSelect";

import update from "immutability-helper";
import axios from 'util/axios';

import { useTranslation } from "react-i18next";
import Draggable from "react-draggable";
import Editor from "./Editor";
import UserList from "pages/Create/DnDTables/UserList";
import { readyValidationData } from "../Create/save";
import { DownloadFile } from "util";

const FirstSOParam = { label: "ALL", code: null, desc: "ALL" };

const getAxios = async ({ postData, master_t, sub_t, in_t, out_t, com_t, qc_t, revInfo, reviewInfo }) => {
    const res = await axios
        .post(process.env.REACT_APP_API + "/pcsCreate/retrieveSheetMaster", postData)
        .then((Response) => {
            return Response.data.data.result;
        })
        .catch((e) => console.error(e));
    if (!!!res || res.master === null) {
        alert("Error");
        window.history.go(-1);
        return;
    }

    let m = { ...res.master };
    let s = [FirstSOParam];
    // Step Operation
    res.sub.forEach((v, i) => {
        s = [
            ...s,
            {
                ...v,
                code: v.soCode,
                label: v.soNm,
                desc: v.description,
                repeat: v.repeat,
                // soSeq: v.soSeq,
            },
        ];
    });

    master_t((v) => ({ ...v, ...m }));
    sub_t(s);
    in_t({ data: res["in"], header: res?.["header"] });
    out_t({ data: res["out"], header: res?.["header"] });
    qc_t({ data: res["qc"], header: res?.["header"] });
    com_t(res["composition"]);
    revInfo(res.revision.maxRevision, res.revision.tempYn);
};

const Detail = () => {
    const { t } = useTranslation(["page"]);
    const dispatch = useDispatch();
    const [SOParams, SetSOParam] = useState([FirstSOParam]);
    const [SelectedSO, SetSelectedSO] = useState(0);
    const tdSelector = useSelector((store) => store.tdSelector);
    const [RevItem, SetRevItem] = useState({});
    const [RevList, SetRevList] = useState([]);
    const [RevCmptCheckList, SetRevCmptCheckList] = useState([]);
    const [ModalOpen, SetModalOpen] = useState(false);
    const [Review, SetReview] = useState(false);
    const [ModalMsg, SetModalMsg] = useState(<p></p>);
    const [RevOpen, SetRevOpen] = useState(false);
    const [RevLogOpen, SetRevLogOpen] = useState(false);
    const [menuOpenS, menuOpen] = useState(true);
    const [Hide, SetHide] = useState(false);
    const userSelector = useSelector((store) => store.user);
    const quillRef = useRef();
    const [inputs, setInputs] = useState({
        plant: "",
        sheetCode: "",
        projectNm: "",
        processCd: "",
        unitCd: "",
        description: "",
        cycle: "1",
        reviewYn: "",
        readyYn: "",
    });

    const [revInputs, setRevInputs] = useState({
        sheetCode: "",
        revision: "",
        uniqueCode: "",
        celNm: "",
        userId: "",
        sheetOwner: "",
        revContent: "",
        revLevel: "",
        tempYn: "",
        sheetType: "",
    });
    const [revUserList, setRevUserList] = useState([]);
    const [soSelected, setSoSelected] = useState({
        name: "",
        index: "",
    });
    const FileInput = useRef();
    const ScrollRef = useRef();

    const autoResizeTextarea = (e) => {
        let textarea = !!e.target ? e.target : e;
        if (textarea) {
            textarea.style.height = "12px";
            let height = textarea.scrollHeight; // 높이
            if (height < 12) {
                height = 12;
            }
            textarea.style.height = `${height}px`;
        }
    };

    const handleModalOpen = (type) => {
        if (type === "temp") SetModalMsg(<p>{t("saved")}</p>);
        else SetModalMsg("");
        SetModalOpen(!ModalOpen);
    };
    const handleReviewOpen = (cellData, uniqueCode, tData, type) => {

        let celNm = cellData.name;

        if (cellData.name === "unit2" || cellData.name === "unit1") {
            celNm = cellData.revCelNm;
        } else {
            celNm = cellData.name;
        }
        setRevInputs({
            sheetCode: mid.current,
            revision: rev.current,
            uniqueCode: uniqueCode,
            celNm: celNm,
            userId: userSelector.userId,
            tempYn: tmp.current,
            sheetType: type,
            sheetOwner: inputs.userId,
        });

        if (cellData.name !== "paraCd") {
            SetReview(true);
        } else {
            SetReview(false);
        }
    };
    const handleClickSQTable = (col, index) => {
        setSoSelected({ name: col, index: index });
    };

    const isUpdate2 = useRef(false);
    const mid = useRef(null);
    const rev = useRef(null);
    const tmp = useRef("N");
    const isAdmin = useRef(false);
    const isReviewer = useRef(false);
    const isReady = useRef(false);
    useEffect(() => {
        isAdmin.current = userSelector.isAdmin;
        isReviewer.current = userSelector.isReviewer;
        isReady.current = userSelector.isReady;
        dispatch({ type: "LOADING_ON" });
        const search = new URLSearchParams(window.location.search);
        mid.current = search.get("mid");
        rev.current = search.get("rev");
        tmp.current = !!search.get("tempYn") ? search.get("tempYn") : "N";
        isUpdate2.current = true;
        try {
            getAxios({
                postData: {
                    sheetcd: mid.current,
                    revision: rev.current,
                    tempYn: tmp.current,
                    userId: userSelector.userId
                },
                master_t: setInputs,
                sub_t: initialSO,
                in_t: in_tbl.current.loadData,
                out_t: out_tbl.current.loadData,
                qc_t: qc_tbl.current.loadData,
                com_t: com_tbl.current.loadData,
                revInfo: RevInfo
            });
            getRevCmptCheckList({
                sheetcd: mid.current,
                revision: rev.current,
                tempYn: tmp.current,
            });
            getUserList({ sheetCode: mid.current });
        } catch (e) { }
        dispatch({ type: "LOADING_OFF" });
    }, []);

    const getUserList = useCallback(
        async (data) => {
            const response = await axios.post(process.env.REACT_APP_API + "/pcsReview/retrieveCallUserList", data);

            const resultData = response.data.data.result;
            setRevUserList(resultData);
        },
        [revUserList]
    );

    const getRevCmptCheckList = useCallback(
        async (data) => {

            const response = await axios.post(
                process.env.REACT_APP_API + "/pcsReview/findRevCmptCheck",
                data
            );
            if (response.status === 200) {
                const resultData = response.data.data.result;
                SetRevCmptCheckList(resultData);
            } else {
                throw new Error("getAxios");
            }
        },
        [RevCmptCheckList]
    );

    const soRef = useRef(null);
    const initialSO = (d) => {
        soRef.current.setData(
            update(d, {
                $splice: [[0, 1]],
            })
        );
    };

    useEffect(() => {
        if (!isUpdate2.current) {
            SetSOParam([FirstSOParam]);
        }
        SetSelectedSO(0);
    }, [inputs.unitCd]);

    const changeSO = (data) => {
        SetSOParam([FirstSOParam, ...data]);
    };

    const OnClickSO = (index) => {
        SetSelectedSO(index);
    };

    const ScrollMove = (direction) => {
        let move = 450;
        if (direction === "left") {
            move = move * -1;
        }
        ScrollRef.current.scrollLeft += move;
    };

    const goCreate = () => {
        const url =
            "/mainForm?mid=" + mid.current + "&rev=" + rev.current + "&tempYn=" + tmp.current;
        window.location.href = url;
    };

    const goCopy = () => {
        const url =
            "/mainForm?copy=Y&mid=" +
            mid.current +
            "&rev=" +
            rev.current +
            "&tempYn=" +
            tmp.current;
        window.location.href = url;
    };
    const readyClick = async (readyYn) => {
        if (readyYn === "Y") {
            readyYn = "N";
        } else {
            readyYn = "Y";
        }
        try {
            readyValidationData({ data: in_tbl.current.getTableData() });
            readyValidationData({ data: out_tbl.current.getTableData() });

            const response = await axios
                .post(process.env.REACT_APP_API + "/pcsCreate/saveSheetReady",
                    {
                        "readyYn": readyYn,
                        "tempYn": tmp.current,
                        "sheetCode": mid.current,
                        "revision": rev.current,
                        "userId": userSelector.userId,
                        "projectNm": inputs.projectNm,
                        "mbrNo": inputs.mbrNo,
                        "processCd": inputs.processCd,
                    }
                )
                .then((Response) => Response.data.data)
                .catch((Error) => {
                    SetModalMsg(<p style={{ textAlign: "center" }}>{Error.toString()}</p>);
                    SetModalOpen(true);
                });
            if (response.result === "ERR108") {
                SetModalMsg(<p style={{ textAlign: "center" }}>{t("ERR108")}</p>);
                SetModalOpen(true);
                return;
            }

            window.location.replace("/detail?mid=" + mid.current + "&rev=" + rev.current + "&tempYn=" + tmp.current);
        } catch (e) {
            SetModalMsg(<p style={{ textAlign: "center" }}>{t(e?.message?.toString())}</p>);
            SetModalOpen(true);
        }

    }
    const RevInfo = (maxRevision, tempYn) => {
        const revSet = new Array(maxRevision).fill().map((v, i) => {
            return { label: i + 1, value: i + 1, temp: "N" };
        });
        if (tempYn == 'Y') {
            const val = maxRevision + "T";
            revSet.push({ label: maxRevision, value: val, temp: "Y" })

            if (rev.current == maxRevision && tmp.current == tempYn) {
                SetRevItem(val);
            } else {
                SetRevItem(rev.current);
            }
        }
        else {
            SetRevItem(rev.current);
        }

        SetRevList(revSet);
        rev.maxRevision = maxRevision;
        rev.tempYn = tempYn;
    };

    const revHandelChange = (e) => {
        if (rev.current == parseInt(e.value) && tmp.current == e.temp) {
            return;
        }
        rev.current = parseInt(e.value);
        tmp.current = !!e.temp ? e.temp : "N";

        SetRevItem(e.value);
        MoveUseEffect();
    };

    const MoveUseEffect = () => {
        dispatch({ type: "LOADING_ON" });
        try {
            getAxios({
                postData: {
                    sheetcd: mid.current,
                    revision: rev.current,
                    tempYn: tmp.current,
                    userId: userSelector.userId
                },
                master_t: setInputs,
                sub_t: initialSO,
                in_t: in_tbl.current.loadData,
                out_t: out_tbl.current.loadData,
                qc_t: qc_tbl.current.loadData,
                com_t: com_tbl.current.loadData,
                revInfo: RevInfo
            });
            getRevCmptCheckList({
                sheetcd: mid.current,
                revision: rev.current,
                tempYn: tmp.current,
            });
        } catch (e) {
            console.log('MoveUseEffect:', e);
        }
        dispatch({ type: "LOADING_OFF" });
    };

    const in_tbl = useRef(null);
    const out_tbl = useRef(null);
    const qc_tbl = useRef(null);
    const com_tbl = useRef(null);

    const DownloadWord = async () => {
        dispatch({ type: "LOADING_ON" });
        const filename =
            inputs.projectNm + "_" + inputs?.mbrNo + "_rev" + inputs.revision + ".docx";
        const response = await axios({
            url: process.env.REACT_APP_API + "/pcsCreate/createWordFile",
            data: {
                sheetcd: inputs.sheetCode,
                revision: inputs.revision,
                tempYn: tmp.current,
            },
            method: "POST",
            responseType: "blob",
        });
        const blob = new Blob([response.data]);

        const fileObjectUrl = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = fileObjectUrl;
        link.style.display = "none";

        link.download = filename;

        document.body.appendChild(link);
        dispatch({ type: "LOADING_OFF" });
        link.click();
        link.remove();

        window.URL.revokeObjectURL(fileObjectUrl);
    };

    const excelDownload = async () => {
        const postData = {
            sheetCode: inputs.sheetCode,
            revision: inputs.revision,
            tempYn: tmp.current,
            projectNm: inputs.projectNm,
            mbrNo: inputs.mbrNo,
            processCd: inputs.processCd
        }
        const excelName = inputs.projectNm + "_" + inputs?.mbrNo + "_rev" + inputs.revision + ".xlsx";
        await DownloadFile({ api: "/pcsCreate/downloadExcelSheetReady", body: postData, name: excelName },)
        window.location.reload();
    }

    const renderRevLog = useMemo(() => {
        if (!RevLogOpen) return null;
        else
            return (
                <ModalPortal>
                    <RevLog
                        onClose={() => SetRevLogOpen(false)}
                        data={{
                            sheetcd: inputs.sheetCode,
                            revision: RevItem,
                        }}
                    ></RevLog>
                </ModalPortal>
            );
    }, [RevLogOpen, RevItem, inputs]);

    const renderRev = useMemo(() => {
        if (!RevOpen) return null;
        else
            return (
                <ModalPortal>
                    <Rev onClose={() => SetRevOpen(false)} data={inputs.sheetCode}></Rev>
                </ModalPortal>
            );
    }, [RevOpen]);

    return (
        <div className="bpl-container" style={{ paddingBottom: "300px" }}>
            <section className="detail">
                <div className="info_top">
                    <table id="head-table">
                        <colgroup>
                            <col width="100" />
                            <col width="100" />
                            <col width="100" />
                            <col width="100" />
                            <col width="350" />
                            <col />
                            <col width="80" />
                            {/* <col width="120" /> */}
                        </colgroup>
                        <thead>
                            <tr>
                                <th>Plant</th>
                                <th>Project</th>
                                <th>MBR No</th>
                                <th>Process</th>
                                <th>Unit Operation</th>
                                <th>Description</th>
                                <th>Cycle</th>
                                {/* <th>Stage</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{inputs?.plant}</td>
                                <td>{inputs?.projectNm}</td>
                                <td>{inputs?.mbrNo}</td>
                                <td>{inputs?.processCd}</td>
                                <td>{inputs?.unitNm}</td>
                                <td>{inputs?.description}</td>
                                <td style={{ textAlign: "right" }}>{inputs?.cycle}</td>
                                {/* <td>{inputs?.stage}</td> */}
                            </tr>
                        </tbody>
                    </table>
                    {inputs.readyYn === "Y" ? <div style={{ float: "right", color: "red" }}><h2>READY</h2></div> : ""}
                </div>

                <div className={"info_middle cf " + (Hide ? "hide" : "")}>
                    <h1 className={"title "} onClick={() => SetHide(!Hide)}>
                        <FontAwesomeIcon icon={faAngleUp} />
                    </h1>
                    <div className={"so-section "}>
                        <div className="left">
                            <SOTable
                                ref={soRef}
                                onChg={changeSO}
                                cycle={inputs?.cycle}
                                onOpen={handleReviewOpen}
                                soSelected={soSelected}
                                setSoSelected={setSoSelected}
                                handleClickSQTable={handleClickSQTable}
                                RevCmptCheckList={RevCmptCheckList}
                            />
                        </div>

                        <div className="right">
                            <div className="revision">
                                <div className="re_top">
                                    <h4>Revision</h4>
                                    {RevList.length > 0 && (
                                        <div className="re_btn" onClick={() => SetRevOpen(true)}>
                                            Rev.History
                                        </div>
                                    )}
                                </div>

                                <div className="re_bottom">
                                    {RevList.length > 0 ? (
                                        <>
                                            <div className="re_left">
                                                <SearchableSelect
                                                    name="rev_history"
                                                    search={false}
                                                    options={RevList}
                                                    value={RevItem}
                                                    textAlign={"center"}
                                                    arrow={true}
                                                    revision={true}
                                                    onChange={revHandelChange}
                                                />
                                            </div>
                                            <div className="re_right">
                                                {
                                                    !RevItem.toString().match(/[0-9]T/) && <div onClick={() => SetRevLogOpen(true)} className="log_btn">
                                                        LOG
                                                    </div>
                                                }

                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <p style={{ textAlign: "center" }}>{t("noRevision")}</p>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="info_bottom">
                    <div className="left">
                        <ul className="arrow">
                            <li onClick={() => ScrollMove("left")}>{"<"}</li>
                        </ul>
                        <ul className="tap" ref={ScrollRef}>
                            {SOParams.map((v, i) => {
                                return (
                                    <li
                                        key={i}
                                        className={SelectedSO === i ? "on" : ""}
                                        onClick={() => OnClickSO(i)}
                                    >
                                        {v.desc}
                                    </li>
                                );
                            })}
                        </ul>
                        <ul className="arrow">
                            <li onClick={() => ScrollMove("right")}>{">"}</li>
                        </ul>
                    </div>

                    <div className={"right " + (menuOpenS ? "active" : "")}>
                        <div className="action_btn">
                            <div className="ab_relative">
                                <div className="contain" onClick={() => menuOpen(!menuOpenS)}>
                                    <FontAwesomeIcon icon={faArrowLeft} />
                                </div>
                            </div>
                            <div className="actions">
                                <ul className="work_btn">
                                    {((inputs.userId === userSelector.userId) && (rev.current == rev.maxRevision && tmp.current == rev.tempYn)) && (
                                        <li className="s_btn" onClick={goCreate}>
                                            Modify
                                        </li>
                                    )}
                                    <li className="s_btn" onClick={goCopy}>
                                        Copy
                                    </li>
                                    {/* {
                                        <li className="f_do" onClick={DownloadWord}>
                                            Download Word File
                                        </li>
                                    } */}
                                    {inputs.readyYn === "Y" && (inputs.userId === userSelector.userId) ?
                                        <li className="f_do" onClick={excelDownload}>
                                            Excel Download
                                        </li>
                                        : null
                                    }
                                    {(inputs.userId === userSelector.userId) ?
                                        <li className="f_do" onClick={() => readyClick(inputs.readyYn)}>
                                            READY {inputs.readyYn === "Y" ? <FontAwesomeIcon icon={faToggleOn}
                                                style={{
                                                    fontSize: "1rem",
                                                    color: "#6300ff"
                                                }} /> :
                                                <FontAwesomeIcon icon={faToggleOff}
                                                    style={{ fontSize: "1rem", color: "#6300ff" }} />}
                                        </li> : ""}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-none">
                    <input type="file" ref={FileInput} />
                </div>
            </section>
            <Editor ref={quillRef} webContent={inputs.webContent} reviewData={RevCmptCheckList}
                onOpen={handleReviewOpen} />
            <COMTable
                ref={com_tbl}
                RevCmptCheckList={RevCmptCheckList}
                unitCd={inputs.unitCd}
                PData={null}
                autoResizeTextarea={autoResizeTextarea}
                onOpen={handleReviewOpen}
            />
            <InTable
                ref={in_tbl}
                RevCmptCheckList={RevCmptCheckList}
                so={SOParams}
                sso={SelectedSO}
                PData={null}
                autoResizeTextarea={autoResizeTextarea}
                onOpen={handleReviewOpen}
            />
            <OutTable
                ref={out_tbl}
                RevCmptCheckList={RevCmptCheckList}
                so={SOParams}
                sso={SelectedSO}
                PData={null}
                PROCode={inputs.processCd}
                autoResizeTextarea={autoResizeTextarea}
                onOpen={handleReviewOpen}
            />
            <QCTable
                ref={qc_tbl}
                RevCmptCheckList={RevCmptCheckList}
                so={SOParams}
                sso={SelectedSO}
                PData={null}
                PROCode={inputs.processCd}
                autoResizeTextarea={autoResizeTextarea}
                onOpen={handleReviewOpen}
            />

            {ModalOpen && (
                <ModalPortal>
                    <Modal onClose={handleModalOpen}>{ModalMsg}</Modal>
                </ModalPortal>
            )}
            {renderRev}
            {renderRevLog}
            {Review && (
                <ReviewDiv
                    tdSelector={tdSelector}
                    onClose={() => SetReview(false)}
                    revInputs={revInputs}
                    setRevInputs={setRevInputs}
                    in_tbl={in_tbl}
                    out_tbl={out_tbl}
                    qc_tbl={qc_tbl}
                    com_tbl={com_tbl}
                    setSoSelected={setSoSelected}
                    getRevCmptCheckList={getRevCmptCheckList}
                    revUserList={revUserList}
                />
            )}
        </div>
    );
};

const ReviewDiv = ({
    tdSelector,
    onClose,
    revInputs,
    setRevInputs,
    in_tbl,
    out_tbl,
    qc_tbl,
    com_tbl,
    setSoSelected,
    getRevCmptCheckList,
    revUserList,
    setRevModeCheck,
}) => {
    const canMove = useRef(true);

    const [reviewList, setReviewList] = useState({ info: {}, list: [] });

    const [userState, setUserState] = useState(false);
    const [userList, setUserList] = useState({ label: "", value: "" });
    const [textAreHtml, setTextAreHtml] = useState({
        revContent: "",
    });
    const textRef = useRef(null);
    const isAdmin = useRef(false);
    const userSelector = useSelector((store) => store.user);
    isAdmin.current = userSelector.isAdmin

    const getReviewList = useCallback(async () => {
        let response;
        try {
            response = await axios.post(process.env.REACT_APP_API + "/pcsReview/list", revInputs);
            const resultData = response.data.data.result;
            const reviewInfo = await axios.post(
                process.env.REACT_APP_API + "/pcsReview/retrieveSheetReviewing",
                revInputs
            ).then(Response => Response.data.data.result)
            setReviewList({ info: reviewInfo, list: resultData });
        } catch (e) {
            console.error(e, response);
        }
    }, [revInputs]);

    useEffect(() => {
        getReviewList()
    }, [getReviewList]);

    const replySave = (replyInputs, setReplyInputs) => {
        const res = axios
            .post(process.env.REACT_APP_API + "/pcsReview/saveReply", replyInputs)
            .then((Response) => {
                getReviewList()

                const payload = {
                    ...replyInputs,
                    revContent: "",
                };
                setReplyInputs(payload);
                return Response.data;
            })
            .catch((e) => console.error(e));
    };

    const cmptTypeUpdate = (cmptType, revNo) => {
        // if(inputs.userId === userSelector.userId ||isAdmin.current){
        const payload = {
            ...revInputs,
            revNo: revNo,
            cmptType: cmptType,
        };

        const res = axios
            .post(process.env.REACT_APP_API + "/pcsReview/modifyCmptType", payload)
            .then((Response) => {
                getReviewList();
                getRevCmptCheckList({
                    sheetcd: revInputs.sheetCode,
                    revision: revInputs.revision,
                    tempYn: revInputs.tempYn,
                });
            })
            .catch((e) => console.error(e));
        // }
    };

    const onChangetextareaHandler = (e, value) => {
        const payload = {
            ...revInputs,
            revContent: value,
            revLevel: 1,
        };

        setRevInputs(payload);
    };

    const revShowHide = (e) => {
        setSoSelected({ name: "", index: "" });

        onClose();
    };

    const textOnview = (e) => {
        const textData = e.target.innerText;

        let user = revUserList.filter(
            (data) =>
                data.label
                    .toLowerCase()
                    .indexOf(textData.toLowerCase().substring(textData.lastIndexOf("@") + 1, textData.length)) !== -1
        );
        if (
            user.length !== 0 &&
            textData !== "" &&
            textData.substring(textData.lastIndexOf("@"), textData.lastIndexOf("@") + 1) === "@"
        ) {
            setUserState(true);
        } else {
            setUserState(false);
        }
        setUserList(user);
    };
    const userClick = (data) => {
        const revContentHtml = textRef.current.innerHTML;
        const textData = revContentHtml?.substring(revContentHtml.lastIndexOf("@"), -1);

        const payloadHtml = {
            revContent:
                textData +
                '<span suppressContentEditableWarning={true} contentEditable="false" class="bpl-reviewerspan" data-userId=' + data.value + '>' +
                "@" +
                data.label +
                "</span>",
        };
        setUserState(false);
        setTextAreHtml(payloadHtml);
    };

    return (
        <section className="detail">
            <Draggable
                onStart={() => {
                    return canMove.current;
                }}
            >
                <div className="prebox">
                    <div className="preTop" style={{ cursor: "all-scroll" }}>
                        <div className="close" onClick={(e) => revShowHide(e)}>
                            <div className="cc c1"></div>
                            <div className="cc c2"></div>
                        </div>
                    </div>
                    <div className="middle">
                        {reviewList.list?.map((data, i) => (
                            <RevData
                                key={`RevData-data-${i}`}
                                data={data}
                                replySave={replySave}
                                cmptTypeUpdate={cmptTypeUpdate}
                                revInputs={revInputs}
                                revUserList={revUserList}
                            />
                        ))}
                    </div>

                    <div className="bottom">
                        {reviewList.info.assignYn === "Y" &&
                            reviewList.info.reviewEnd !== "Y" &&
                            reviewList.info.reviewing === "I" ? (
                            <>
                                <div
                                    style={{
                                        position: "relative",
                                        flex: 3,
                                        height: "100%",
                                        marginRight: 15,
                                    }}
                                >
                                    <div className="box_txa" style={{ padding: 5 }}>
                                        <ComTextarea
                                            ref={textRef}
                                            onview={textOnview}
                                            revInputs={revInputs}
                                            onChangetextareaHandler={onChangetextareaHandler}
                                            textAreHtml={textAreHtml}
                                        />
                                    </div>
                                    {userState && (
                                        <div
                                            style={{
                                                position: "absolute",
                                                top: "auto",
                                                left: 0,
                                                right: 0,
                                                bottom: "100%",
                                                height: 200,
                                                border: "1px solid #aaa",
                                                background: "white",
                                            }}
                                        >
                                            <UserList user={userList} userClick={userClick} />
                                        </div>
                                    )}
                                </div>

                            </>
                        ) : (
                            <></>
                        )}
                    </div>
                </div>
            </Draggable>
        </section>
    );
}; export default Detail;
